export default [
  'Agriculture energy efficiency',
  'Air - rail - marine',
  'Bioenergy',
  'Building energy efficiency',
  'Carbon capture and storage',
  'Energy efficiency',
  'Grid',
  'Hydrogen and fuel cells',
  'Industry energy efficiency or substitution',
  'Nuclear',
  'Other renewables',
  'Renewable energy integration in buildings',
  'Renewables',
  'Solar',
  'Storage (not e-mobility)',
  'Vehicle fuel efficiency',
  'Wind',
  'e-Mobility',
];
